import { render, staticRenderFns } from "./RoomSaleUpdate.vue?vue&type=template&id=0a16f10c"
import script from "./RoomSaleUpdate.vue?vue&type=script&lang=js"
export * from "./RoomSaleUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports